import React from 'react';
import { array, object } from 'prop-types';
import styled from 'styled-components';
import { H2, BodyText } from '../Text/Heading';

const MobileHeader = styled(BodyText)`
  line-height: 19px;
`;
MobileHeader.displayName = 'MobileHeader';
MobileHeader.defaultProps = {
  color: 'greyDark',
  display: ['block', 'none'],
  margin: '25px 0 20px 0',
};

const LargeHeader = styled(H2)`
  margin-bottom: 9px;
  line-height: 36px;
`;
LargeHeader.displayName = 'LargeHeader';
LargeHeader.defaultProps = {
  display: ['none', 'block'],
};

const ListHeader = ({ desktopStyles, mobileStyles, children }) => (
  <>
    <MobileHeader className="mobile-header" {...mobileStyles}>
      {children}
    </MobileHeader>
    <LargeHeader className="large-header" {...desktopStyles}>
      {children}
    </LargeHeader>
  </>
);

ListHeader.propTypes = {
  children: array,
  mobileStyles: object,
  desktopStyles: object,
};

export default ListHeader;
